import React, { useState } from 'react'
import { GetServerSideProps } from 'next'
import getEMTServerSideProps, { EMTServerSideProps } from '@/helpers/getEMTServerSideProps'
import { SEO, withPrivateRoute } from '@/components'
import { useRouter } from 'next/router'
import { useIsQueryOwner } from '@/hooks'
import { Navigation } from '@/components/EMT/Navigation'
import { useMobile } from 'emt-components-v2'
import Box from '@mui/material/Box'
import ProfileComponent from '@/components/Profile/ProfileComponent'
// import { useEMTDispatch } from '@/store'
// import { AuthServiceHelper } from '@/modules/Auth'
// import GlobalLoader from '@/components/GlobalLoader'
// import { appendParamsIfNeeded } from '@/utils'

type Props = EMTServerSideProps

const ViewProfilePage: React.FC<Props> = ({ url, title }) => {
  const [isMobile] = useMobile()
  const [userProfileName, setUserProfileName] = useState<string>()
  const router = useRouter()
  const [, type] = useIsQueryOwner()

  // TODO: Uncomment this one when activating public profiles
  // const dispatch = useEMTDispatch()
  //
  // const [isLoading, setLoading] = useState<boolean>(true)
  //
  // React.useEffect(() => {
  //   const checkIsLoggedAsync = async () => {
  //     try {
  //       const logged = await AuthServiceHelper.dispatchCheckAuthStatusAsync(dispatch)(false)
  //
  //       if (!logged) {
  //         // Not logged in, redirect to /view-public-profile/id
  //         const customerId = router.query['customer-id'] as string
  //
  //         router.replace(appendParamsIfNeeded(`/view-public-profile/${customerId}`, {}))
  //       } else {
  //         setLoading(false)
  //       }
  //     } catch (error) {
  //       console.debug(error)
  //       setLoading(false)
  //     }
  //   }
  //
  //   checkIsLoggedAsync().finally()
  // }, [])
  //
  // if (isLoading) {
  //   return <GlobalLoader />
  // }

  return (
    <>
      <SEO url={`${url}`} subtitle={userProfileName ? userProfileName : title} />
      {!isMobile && (
        <Box sx={{ overflow: 'hidden' }}>
          <Navigation />
        </Box>
      )}
      {type && (
        <ProfileComponent
          customerId={router.query['customer-id'] as string}
          getUserProfileName={(name: string) => setUserProfileName(name)}
        />
      )}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = getEMTServerSideProps({
  namespaces: ['common', 'profile', 'message', 'petsitter', 'connection'],
  i18nTitleNs: 'profile',
  i18nTitleKey: 'title',
})

export default withPrivateRoute()(ViewProfilePage)
